const ADD_TO_CART_LABEL = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 w-5 h-5" style="margin-right:0.5rem"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg> Add to Cart`;

// Quote-only variants (variant metafield pulse.intended_use === 'quote_only') cannot use
// automated checkout. Their standard cart flow is hidden and a competition-use quote request
// (a Shopify contact form) is shown instead. Standard variants keep the normal cart flow.
function updateProductQuoteGate(form, variant) {
  if (!form) return;
  const metadata = form.querySelector('[data-product-metadata]');
  const addButton = form.querySelector('[data-product-add-button]');
  if (!metadata || !addButton) return;

  if (variant) {
    metadata.dataset.variantTitle = variant.title || '';
    metadata.dataset.variantAvailable = String(Boolean(variant.available));
    metadata.dataset.variantQuoteOnly = String(Boolean(variant.quoteOnly));
  }

  const quoteOnly = metadata.dataset.variantQuoteOnly === 'true';
  const available = metadata.dataset.variantAvailable === 'true';

  // The container holding the standard cart button lives outside the form; scope from the form's parent.
  const scope = form.parentElement || document;
  const quoteBlock = scope.querySelector('[data-product-quote-block]');
  const variantField = scope.querySelector('[data-product-quote-variant]');

  // Toggle standard cart button vs. quote request block.
  addButton.classList.toggle('hidden', quoteOnly);
  addButton.disabled = quoteOnly || !available;

  if (quoteBlock) quoteBlock.classList.toggle('hidden', !quoteOnly);
  if (variantField && variant && variant.title) variantField.value = variant.title;

  if (!quoteOnly) {
    if (available) {
      addButton.innerHTML = ADD_TO_CART_LABEL;
    }
    return;
  }

  // Ensure the panel starts collapsed each time we switch to a quote-only variant.
  const panel = scope.querySelector('[data-product-quote-panel]');
  if (panel) panel.classList.add('hidden');
}

function initProductQuoteForm(scope) {
  scope.querySelectorAll('[data-product-quote-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const panel = toggle.parentElement?.querySelector('[data-product-quote-panel]');
      if (panel) panel.classList.toggle('hidden');
    });
  });
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMasterInput();
    this.updateURL();
    this.updatePrice();
    this.updateButton();
    this.updateQuoteGate();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMasterInput() {
    const idInput = this.closest('form')?.querySelector('input[name="id"]');
    if (idInput && this.currentVariant) {
      idInput.value = this.currentVariant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateButton() {
    const addButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
    if (!addButton) return;

    // Quote-only variants remain selectable even when unavailable for sale; the quote
    // request block (handled by updateQuoteGate) replaces the standard cart button, so
    // never surface "Out of Stock" for them.
    if (this.currentVariant?.quoteOnly) {
      return;
    }

    if (!this.currentVariant) {
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
    } else if (!this.currentVariant.available) {
      addButton.disabled = true;
      addButton.textContent = 'Out of Stock';
    } else {
      addButton.disabled = false;
      addButton.innerHTML = ADD_TO_CART_LABEL;
    }
  }

  updateQuoteGate() {
    updateProductQuoteGate(
      this.closest('form'),
      this.currentVariant || { title: '', available: false, quoteOnly: false },
    );
  }

  updatePrice() {
    const priceEl = document.getElementById(`ProductPrice-${this.dataset.section}`);
    if (!priceEl || !this.currentVariant) return;
    
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
    
    priceEl.textContent = formatter.format(this.currentVariant.price / 100);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus' || event.target.closest('button').name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pulse-product-form').forEach((form) => {
    updateProductQuoteGate(form);
    initProductQuoteForm(form.parentElement || document);
  });

  const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (toggleBtn && mobileMenu) {
    toggleBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
      toggleBtn.setAttribute('aria-expanded', String(!mobileMenu.classList.contains('hidden')));
    });
  }
});
